import placeholderDarkUrl from "@/assets/images/placeholder-dark.svg";
import placeholderUrl from "@/assets/images/placeholder.svg";
import { useComputedColorScheme } from "@mantine/core";

export const usePlaceholderHook = () => {
  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });

  return computedColorScheme === "light" ? placeholderUrl : placeholderDarkUrl;
};
